export const SET_SELECTED_ACADEMIC_YEAR_GLOBALLY = 'SET_SELECTED_ACADEMIC_YEAR_GLOBALLY'
export const SET_COURSE_IS_EXPANDED = 'SET_COURSE_IS_EXPANDED'
export const SET_LEVEL_IS_EXPANDED = 'SET_JOURNEY_IS_EXPANDED'
export const CLEAR_EXPANDED_LEVELS = 'CLEAR_EXPANDED_JOURNEYS'

export function setSelectedAcademicYearGlobally (academicYear): Action {
  return {
    type: SET_SELECTED_ACADEMIC_YEAR_GLOBALLY,
    payload: {
      academicYear: academicYear
    }
  }
}

export function setCourseIsExpanded (id, isExpanded): Action {
  return {
    type: SET_COURSE_IS_EXPANDED,
    payload: {
      id,
      isExpanded
    }
  }
}

export function setLevelIsExpanded (id, isExpanded): Action {
  return {
    type: SET_LEVEL_IS_EXPANDED,
    payload: {
      id,
      isExpanded
    }
  }
}

export function clearExpandedLevels (): Action {
  return {
    type: CLEAR_EXPANDED_LEVELS
  }
}



// WEBPACK FOOTER //
// ./src/actions/mycourses.js